import type { IComponent } from "@Components/Component";
import type { IPanel } from "@Components/Panel";
import { Panel } from "@Components/Panel";

import type { ILocationInfo } from "../location/LocationInfo";
import { LocationInfo } from "../location/LocationInfo";

import * as css from "./ShoppingMallsFilters.module.css";

export interface IShoppingMallsFiltersHeader extends IComponent, IPanel {
    locationInfo?: ILocationInfo;
}

export const ShoppingMallsFiltersHeader = (props: IShoppingMallsFiltersHeader) => (
    <Panel {...props} className={css.shoppingMallsFiltersHeaderComponent}>
        <LocationInfo {...props.locationInfo} />
    </Panel>
);
